import React from "react";

import DW1 from "../../../../assets/images/dwarve1.png";
import DW2 from "../../../../assets/images/dwarve2.png";
import DW3 from "../../../../assets/images/dwarve3.png";

import blue from "../../../../assets/images/blue.png";
import red from "../../../../assets/images/red.png";
import green from "../../../../assets/images/green.png";
import gold from "../../../../assets/images/gold.png";
import silver from "../../../../assets/images/silver.png";
import yellowwave from "../../../../assets/images/yellow-wave.svg";
import yellow1 from "../../../../assets/images/yellow1.svg";
import bluewave from "../../../../assets/images/blue-wave.svg";
import blue2 from "../../../../assets/images/blue2.svg";

import "./Program.scss";

const Program = () => {
  return (
    <>
      <div className="program_container">
        {/* <img
          src={blue2}
          alt=""
          style={{ width: "150%", margin: "0% 0% 0% -24%" }}
        /> */}
        <div className="box1">
          <div className="data">
            <div className="title">Kingdom Coins</div>
            <div className="detail">
              {" "}
              There will 1,111 available to mint during pre and public sale
            </div>
            <div className="dis">
              <p>
                1,111 Kingdom coins from the Dwarven Empire. Each coin
                represents a clan leader and their treasure. <br />
                <br /> Kingdom coins have additional super-rare utility which is
                included in our roadmap Anyone who mints a Kingdom Coin will be
                joining a subsidiary project as part of the ADT eco-system.{" "}
                <br />
                <br /> 25% of the mint revenue from Kingdom Coins specifically
                will be put into a separate community wallet for the holders to
                create their own project, design, launch and take to market
                within a timescale they can manage. (with the full help and
                support of the project team and ADT community) The holders of
                the Kingdom Coins who launch their project will also get 30% of
                the mint revenue for the project they choose to launch + the
                royalties returned to their community wallet for future
                endeavors.
                <br />
                <br />
                Additionally* Within the 1,111 Kingdom Coins there will be 1
                LEADER kingdom coin who will become the project lead of the
                breakaway project.
              </p>
            </div>

            {/* <Button style={{ color: "#0FFFF7",  border:"2px solid #0FFFF7", backgroundColor: "#000000", width: "200px" }}> Learn more </Button> */}
          </div>

          <div className="img_box">
            <img src={blue} alt="ERROR" />
            <img src={red} alt="" />
            <img src={green} alt="" />
            <img src={gold} alt="" />
            <img src={silver} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Program;
